module.exports = {"goodmorning":"Guten Morgen","goodday":"Ich hoffe du hast einen sch�nen Tag"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/de.json
// module id = 201
// module chunks = 0